<template>
  <template v-if="loading">
    <AdminLoadingAction />
  </template>
  <template v-else>
    <v-container fluid class="pa-4">
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
            <h2 class="font-weight-bold" v-if="!editingMode">사원 목록</h2>
            <h2 class="font-weight-bold" v-if="editingMode">사원 등록 및 수정</h2>
          </div>
          
          <div class="d-flex align-center">
            <v-btn
              v-if="editingMode"
              class="btnColorWhite mr-2"
              text="목록으로 돌아가기"
              @click="editingModeFalse()"
            ></v-btn>

            <v-btn v-if="!editingMode" class="btnColorWhite mr-2" @click="editingMode = true">
              등록
            </v-btn>

            <v-btn @click="dialog = true" class="btnColorWhite mr-2">필터</v-btn>

            <v-text-field
              class="inoutSearchInput ml-2"
              style="
                background-color: #fff;
                max-width: 200px;
                width: auto;
                min-width:190px;
              "
              v-model="search"
              color="#0f7545"
              label="이름/직위 검색"
              single-line
              clearable
              :append-inner-icon="mdiMagnify"
              flat
              hide-details="auto"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <!-- 수정로직 -->
          <v-row v-if="editingMode === true" class="nonPM">
            <v-col cols="3">
              <v-sheet style="border-right: 1px solid #e6deef">
                <v-data-table
                  no-data-text="사원을 등록해주세요."
                  fixed-header
                  density="compact"
                  scrollable
                  :headers="updateHeadersArr"
                  :items="filteredItems"
                  :search="search"
                  item-value="name"
                  class="SsEmpWorkPayTypeTb SsEmpListTb fontNotoSans400"
                  :items-per-page="-1"
                  :items-per-page-options="[
                    { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
                  ]"
                >
                  <template v-slot:item="{ item, index }">
                    <tr
                      :class="['SsEmpListTbTr', { selected: selectedRowIndex === index }]"
                      @click="() => handleRowClick(item, index)"
                    >
                      <td class="text-center">{{ item.emp_num }}</td>
                      <td class="text-center">{{ item.emp_name }}</td>
                      <td class="text-center">{{ item.emp_job }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-btn @click="() => handleRowClickBlank()" color="#333" style="width: 100%"
                  >사원등록</v-btn
                >
              </v-sheet>
            </v-col>
            <v-col cols="9">
              <AdminEmpDetail @success="readEmpInfo" />
            </v-col>
          </v-row>
          <!-- 수정로직 -->

          <div v-if="editingMode === false" class="table-container">
            <v-data-table
              no-data-text="사원을 등록해주세요."
              fixed-header
              density="compact"
              scrollable
              :headers="headersArr"
              :items="filteredItems"
              :search="search"
              item-value="name"
              class="adminDataTb custom-table"
              :items-per-page="-1"
              :items-per-page-options="[
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
              ]"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  :class="{ activeSsTr: expandedRows.includes(index) }"
                  class="SsTbTr"
                >
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.emp_num || "" }}</td>
                  <td class="text-center">{{ item.emp_name || "" }}</td>
                  <td class="text-center">{{ item.emp_job || "" }}</td>
                  <td class="text-center">{{ item.emp_birth_num_front || "" }}</td>
                  <td class="text-center">
                    {{ item.emp_phone?.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") || "" }}
                  </td>
                  <td class="text-center">{{ item.emp_email || "" }}</td>
                  <td>{{ item.emp_addr || "" }}</td>
                  <td>
                    {{ item.emp_bank }}<span v-if="item.emp_bank_num">({{ item.emp_bank_num }})</span><span v-if="item.emp_bank_owner">({{ item.emp_bank_owner }})</span>
                  </td>
                  <td class="text-center">{{ item.emp_in_date || "" }}</td>

                  <td class="text-center">
                    <v-chip color="black" v-if="item.emp_status === 0">
                      {{ item.status_name }}
                    </v-chip>
                    <v-chip color="green-darken-4" v-else-if="item.emp_status === 1">
                      {{ item.status_name }}
                    </v-chip>
                    <v-chip color="orange-darken-4" v-else-if="item.emp_status === 2">
                      {{ item.status_name }}
                    </v-chip>
                    <v-chip color="blue-darken-1" v-else-if="item.emp_status === 3">
                      {{ item.status_name }}
                    </v-chip>
                  </td>
                  <td class="text-center" @click="toggleRowDetails(item, index)">
                    <v-btn class="toggleRowDetailsBtn" color="grey-lighten-3">수정</v-btn>
                  </td>
                </tr>
                <td class="bonusTd" :colspan="headersArr.length">
                  <v-expand-transition>
                    <div v-show="expandedRows.includes(index)">
                      <div class="flexCenter">
                        <div class="SsEmpDetailTitle">
                          <h4>상세정보</h4>
                        </div>
                        <v-divider inset vertical class="SsVerticalDivider"></v-divider>
                        <div class="SsEmpDetailContent">
                          <p v-if="item.emp_birth_num">
                            주민번호 : {{ `${item.emp_birth_num?.slice(0, 6)}-*******` || null }}
                          </p>
                          <p v-else></p>
                          <p>자택주소 : {{ item.emp_addr }}</p>
                          <p v-show="item.emp_out_date">퇴사일자 : {{ item.emp_out_date }}</p>
                        </div>
                        <div class="SsEmpDetailTitle">
                          <h4>계좌정보</h4>
                        </div>
                        <v-divider inset vertical class="SsVerticalDivider"></v-divider>
                        <div class="SsEmpDetailContent">
                          <p>사용은행 : {{ item.emp_bank }}</p>
                          <p>계좌번호 : {{ item.emp_bank_num }}</p>
                          <p>예금주명 : {{ item.emp_bank_owner }}</p>
                        </div>
                        <div class="SsEmpDetailTitle">
                          <h4>메모</h4>
                          <span style="font-size: 10px; opacity: 0.8">(300자)</span>
                        </div>
                        <div v-if="memoLoading" class="memoSpainner text-center SsEmpDetailMemo"></div>
                        <div v-else class="SsEmpDetailMemo">
                          <v-textarea
                            v-model="item.emp_memo"
                            rows="2"
                            variant="outlined"
                            maxlength="300"
                            width="300px"
                            hide-details="auto"
                            @focus="focusMemo(item)"
                            @blur="updateEmpMemo(item)"
                          ></v-textarea>
                        </div>
                        <div class="SsEmpDetailTitle">
                          <h4>상태변경</h4>
                        </div>
                        <v-divider inset vertical class="SsVerticalDivider"></v-divider>
                        <div class="SsEmpDetailContent">
                          <select
                            v-model="item.status_name"
                            @change="updateEmpStatus(item)"
                            style="
                              cursor: pointer;
                              border: 1px solid #454545;
                              padding: 6px 10px;
                              border-radius: 5px;
                            "
                          >
                            <option
                              class="text-center"
                              v-for="status in statusOptions2"
                              :key="status"
                              :value="status"
                            >
                              {{ status }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </v-expand-transition>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="dialog" height="800px" class="fontNotoSans400">
      <v-card class="SsFilterCard">
        <v-card-title class="SsFilterCardTitle text-center">
          <h3 style="margin-left: 10px">직원 검색 필터</h3>
          <v-btn
            style="float: right; margin-right: 10px"
            class="btnColorWhite"
            @click="allSelectDie()"
          >전체 체크해제</v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <b>직원 상태</b>
              <v-sheet class="filter-sheet">
                <div v-for="status in statusOptions" :key="status.value" class="inline-div">
                  <v-checkbox
                    color="secondary"
                    :label="status.label"
                    v-model="selectStatus"
                    :value="status.value"
                    hide-details
                    size="small"
                  />
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="6">
              <b>직원 직위</b>
              <v-sheet class="filter-sheet">
                <div v-for="job in jobOptions" :key="job.value" class="inline-div">
                  <v-checkbox
                    :label="job.label"
                    v-model="selectJob"
                    :value="job.value"
                    hide-details
                    size="small"
                  />
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false" class="cancelRegistBtn" block>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import { mdiMagnify } from "@mdi/js";
import axios from "axios";
import AdminLoadingAction from "../../../components/admin/layout/AdminLoadingAction.vue";
import { useStore } from 'vuex';
const store = useStore();
import AdminEmpDetail from "../../../components/admin/basic-info/AdminEmpDetail.vue";

interface Employee {
  emp_num: string;
  emp_name: string;
  emp_job: string;
  emp_birth_num_front: string;
  emp_phone: string;
  emp_email: string;
  emp_addr: string;
  emp_bank: string;
  emp_in_date: string;
  emp_status: number;
  emp_memo?: string;
  status_name?: string;
  [key: string]: string | number | undefined;
}

interface Header {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}

interface EmpItem {
  emp_num: string;
  emp_name: string;
  emp_job: string;
}

interface HeaderItem {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}

const editingMode = ref(false);
const editingModeFalse = async () => {
  editingMode.value = false;
};
let originalEmp = ref("");
let originalMemo = ref("");

const loading = ref(false);
const memoLoading = ref(false);
const empList = ref<Employee[]>([]);
const code = ref<string>(store.state.AdminSisulCode);
const search = ref("");
const dialog = ref(false);

const selectStatus = ref<number[]>([1, 2, 3, 0]);
const statusOptions = [
  { label: "현원", value: 1 },
  { label: "유급휴가", value: 2 },
  { label: "무급휴가", value: 3 },
  { label: "퇴사", value: 0 },
];
const statusOptions2 = ["현원", "유급휴가", "무급휴가","퇴사"];
const selectJob = ref<string[]>([
  "시설장",
  "사회복지사",
  "간호사",
  "간호조무사",
  "물리치료사",
  "사무장",
  "사무원",
  "영양사",
  "조리사",
  "조리원",
  "위생원",
  "요양보호사",
  "운전사",
  "기타",
]);
const jobOptions = [
  { label: "시설장", value: "시설장" },
  { label: "사회복지사", value: "사회복지사" },
  { label: "간호사", value: "간호사" },
  { label: "간호조무사", value: "간호조무사" },
  { label: "물리치료사", value: "물리치료사" },
  { label: "사무장", value: "사무장" },
  { label: "사무원", value: "사무원" },
  { label: "영양사", value: "영양사" },
  { label: "조리사", value: "조리사" },
  { label: "조리원", value: "조리원" },
  { label: "위생원", value: "위생원" },
  { label: "요양보호사", value: "요양보호사" },
  { label: "운전사", value: "운전사" },
  { label: "기타", value: "기타" },
];
const allSelectDie = () => {
  selectStatus.value = [];
  selectJob.value = [];
};
const headersArr = ref<Header[]>([
  { title: "No.", key: "index", align: "center", sortable: false },
  { title: "사원번호", key: "emp_num", align: "center", sortable: true },
  { title: "이름", key: "emp_name", align: "center", sortable: true },
  { title: "직위", key: "emp_job", align: "center", sortable: true },
  { title: "생년월일", key: "emp_birth_num_front", align: "center", sortable: true },
  { title: "휴대폰", key: "emp_phone", align: "center", sortable: true },
  { title: "이메일", key: "emp_email", align: "center", sortable: true },
  { title: "주소", key: "emp_addr", align: "center", sortable: true },
  { title: "은행", key: "emp_bank", align: "center", sortable: true },
  { title: "입사일", key: "emp_in_date", align: "center", sortable: true },
  { title: "상태", key: "emp_status", align: "center", sortable: true },
  { title: "기능", key: "", align: "center", sortable: false },
]);
const filteredItems = computed(() => {
  const hasStatusFilter = selectStatus.value.length > 0;
  const hasJobFilter = selectJob.value.length > 0;

  if (!hasStatusFilter && !hasJobFilter) {
    return [];
  }

  return empList.value.filter((item) => {
    let searchTerm: string | null = null;
    if (!search.value) {
      searchTerm = search.value;
    } else {
      searchTerm = search.value.trim().toLowerCase();
    }

    const matchesSearch =
      !searchTerm ||
      (item.emp_name && item.emp_name.toLowerCase().includes(searchTerm)) ||
      (item.emp_job && item.emp_job.toLowerCase().includes(searchTerm));

    const matchesStatus =
      !hasStatusFilter || selectStatus.value.includes(item.emp_status);

    const matchesJobs = !hasJobFilter || selectJob.value.includes(item.emp_job);

    return matchesSearch && matchesStatus && matchesJobs;
  });
});
// const show = ref(false);
const showVal = () => {
  // show.value = !show.value
};
const expandedRows = ref([] as number[]);
const toggleRowDetails = (item: Employee, index: number) => {
  showVal();
  editingMode.value = true;
  selectedRowIndex.value = index;
  store.commit("setSsECDEmpInfo", item);
};
const focusMemo = (item: Employee) => {
  originalEmp.value = item.emp_num;
  originalMemo.value = item.emp_memo || '';
};
const updateEmpMemo = async (item: Employee) => {
  if (memoLoading.value === true) return;

  if (item.emp_memo === originalMemo.value && item.emp_num === originalEmp.value) {
    return;
  }
  if (!item.emp_memo || item.emp_memo === "") {
    item.emp_memo = "isNullTextPOSTMEMO";
  }
  try {
    const empMemo = encodeURIComponent(item.emp_memo);
    memoLoading.value = true;
    const response = await axios.post(
      `/api/updateEmpMemo/${empMemo}/${item.emp_num}/${code.value}`
    );
    const result = response.data;
    if (result.success) {
      await readEmpInfo();
    }
  } catch (error) {
    console.error(error);
    throw error;
  } finally {
    memoLoading.value = false;
  }
};

const updateEmpStatus = async (item: Employee) => {
  try {
    let empStatus = 0;
    if (item.status_name === "현원") {
      empStatus = 1;
    } else if (item.status_name === "유급휴가") {
      empStatus = 2;
    } else if (item.status_name === "무급휴가") {
      empStatus = 3;
    }
    const response = await axios.post(
      `/api/updateEmpStatus/${empStatus}/${item.emp_num}/${code.value}`
    );
    const result = response.data;
    if (result.success) {
      await readEmpInfo();
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
const readEmpInfo = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/readEmpInfo/${code.value}`);
    const responseData = response.data;
    if (responseData) {
      empList.value = responseData;

      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    loading.value = false;
    distroyHandleRowClick();
  }
};
//수정로직
const selectedRowIndex = ref<number | null>(null);
const handleRowClick = (item: EmpItem, index: number) => {
  selectedRowIndex.value = index;
  store.commit("setSsECDEmpInfo", item);
};

const handleRowClickBlank = () => {
  selectedRowIndex.value = null;
  store.commit("setSsECDEmpInfo", []);
};
const distroyHandleRowClick = () => {
  selectedRowIndex.value = null;
  store.commit("setSsECDEmpInfo", "notSelectStatus");
};
const updateHeadersArr = ref<HeaderItem[]>([
  { title: "사원번호", key: "emp_num", align: "center", sortable: true },
  { title: "이름", key: "emp_name", align: "center", sortable: true },
  { title: "직위", key: "emp_job", align: "center", sortable: true },
]);
//수정로직

onMounted(async () => {
  await readEmpInfo();
  store.commit("setSsECDEmpInfo", []);
});
onUnmounted(() => {
  loading.value = false;
  sessionStorage.removeItem("getSsECDEmpInfo");
});
</script>
<style scoped>
.SsFilterCard {
  width: 630px;
  margin: auto;
  display: inline;
  overflow-y: auto;
  overflow-x: auto;
}

.SsFilterCardTitle {
  background: linear-gradient(45deg, #e89e7e, #ff9b70);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-sheet {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.inline-div{
  display: inline-block;
  justify-items: start !important;
  width: 120px;
}
.inline-div .v-label{
  opacity: 1 !important;
}
.v-selection-control {
  min-height: 0 !important;
  max-height: 30px !important;
}
.toggleRowDetailsBtn{
  height: 20px;
  padding: 0 !important;
}
.SsEmpListTbTr{
  cursor: pointer;
}
.SsEmpListTbTr:hover{
  background-color: #f0f0f0 !important;
}
.SsEmpListTbTr.selected {
  background-color: #e6deef !important;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  padding: 16px 0;
}

.custom-table {
  width: 100% !important;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-table :deep(th) {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
  text-transform: none;
  letter-spacing: 0;
}

.custom-table :deep(th), .custom-table :deep(td) {
  padding: 8px 16px;
  white-space: nowrap;
}

.custom-table :deep(tbody tr:hover) {
  background-color: #f0f0f0 !important;
}
.bonusTd{
  display: none;
}
</style>